import {
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
} from "../../../Constants/types";

export const topicTypes = [
  "Entertainment",
  "Fun",
  "Goals",
  "Inspo",
  "Motivation",
  "Personality",
  "Socialising",
  "Throwback",
  "Unwinding",
  "Wellness",
].sort();

export const layerTypes = [
  {
    value: "subtitle",
    label: "Subtitle",
  },
  {
    value: "paragraph",
    label: "Paragraph",
  },
  {
    value: "picture and paragraph",
    label: "Picture and Paragraph",
  },
  {
    value: "standout paragraph",
    label: "Standout Paragraph",
  },
  {
    value: "quote",
    label: "Quote",
  },
  {
    value: "question",
    label: "Question",
  },
  {
    value: "agreeableness",
    label: "Agreeableness",
  },
  {
    value: "token earning task",
    label: "Token Earning Task",
  },
  {
    value: "poll",
    label: "Poll",
  },
  {
    value: "event",
    label: "Event",
  },
  {
    value: "product",
    label: "Product",
  },
  { value: IMAGE_UPLOAD, label: "Upload Image" },
  { value: GIF_UPLOAD, label: "Upload Gif" },
  { value: VIDEO_UPLOAD, label: "Upload Video" },
  { value: YOUTUBE_URL, label: "Link Video" },
];

export const tabs = ["Article Content", "Article Tags"];



// WEBPACK FOOTER //
// ./src/screens/Articles/constants/selections.js